"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseQuery_1 = require("./BaseQuery");

var applySubQueryPlaceholders_1 = require("../utils/applySubQueryPlaceholders");

var AssetQuery =
/** @class */
function (_super) {
  __extends(AssetQuery, _super);

  function AssetQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AssetQuery.prototype.initialize = function (executionOptions) {
    this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
  };

  AssetQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        key = _a.key,
        keyQuery = _a.keyQuery,
        subQueries = _a.subQueries,
        _b = _a.assetOptions,
        assetOptions = _b === void 0 ? {} : _b,
        _c = _a.options,
        options = _c === void 0 ? {} : _c;
    var source = assetOptions.source,
        applicationGuid = assetOptions.applicationGuid;
    return __assign({
      key: key,
      keyQuery: keyQuery,
      subQueries: subQueries,
      source: source,
      applicationGuid: applicationGuid
    }, options.asset || {});
  };

  AssetQuery.prototype.getRawValue = function (executionOptions) {
    var key = this.options.key;
    var _a = this.options,
        subQueries = _a.subQueries,
        allSubQueryValuesRequired = _a.allSubQueryValuesRequired,
        _b = _a.source,
        source = _b === void 0 ? 'currentAppAsset' : _b,
        applicationGuid = _a.applicationGuid;
    key = applySubQueryPlaceholders_1.applySubQueryPlaceholders({
      executionOptions: executionOptions,
      subQueries: subQueries,
      allSubQueryValuesRequired: allSubQueryValuesRequired,
      template: key
    });
    var baseUrl = '';

    if (executionOptions.serviceUrl) {
      var serviceUrl = executionOptions.serviceUrl;
      baseUrl = serviceUrl.endsWith('/') ? serviceUrl.substr(0, serviceUrl.length - 1) : serviceUrl;
    }

    var src = baseUrl + "/applicationManager/apps";

    switch (source) {
      case 'ksysAsset':
        src = src + "/ksys-app-assets/" + key;
        break;

      case 'appGuidAsset':
        src = src + "/" + applicationGuid + "/" + key;
        break;

      case 'currentAppAsset':
      default:
        src = src + "/" + executionOptions.applicationGuid + "/" + key;
        break;
    }

    return src;
  };

  return AssetQuery;
}(BaseQuery_1.BaseQuery);

exports.AssetQuery = AssetQuery;